<template>
  <v-container>
    <v-row v-if="notification && notification.formatted">
      <v-col cols="4" class="pt-0">
        <v-row>
          <v-col class="text-h5">
            Assets
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              :value="notification.formatted.name"
              label="Alert Name"
              :error-messages="errorMessageName"
              class="pt-0"
              :maxlength="75"
              :disabled="readOnly"
              @input="handleChangeName"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-radio-group
              :value="notification.formatted.docType"
              label="Asset types"
              class="mt-0 pt-0"
              :disabled="readOnly"
              @change="handleChangeAssetType"
            >
              <v-radio
                v-for="item in assetTypes"
                :key="item.value"
                :label="item.text"
                :value="item.value"
                :disabled="typesDisabled.includes(item.value)"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1"></v-col>
      <v-col>
        <span class="text-h6">{{ assetTypeTitle }}</span>

        <NotificationsAssets :read-only="readOnly"></NotificationsAssets>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashGet from "lodash/get";
import lodashFind from "lodash/find";
import lodashCloneDeep from "lodash/cloneDeep";
import lodashOrderBy from "lodash/orderBy";

import { MODULE_PREFIX_NOTIFICATIONS } from "@/store";
import { GET_NOTIFICATION } from "@/store/actions.type";
import { mapGetters } from "vuex";
import {
  NOTIFICATION_ASSET_TYPES,
  NOTIFICATION_ASSET_TYPE_RISK_RATING,
  NOTIFICATION_ASSET_TYPE_VERIFIED_EVENT,
  NOTIFICATION_ASSET_TYPE_HOTSPOT,
  NOTIFICATION_ASSET_TYPE_SAVED_SEARCH,
} from "@/common/constants/notifications";

export default {
  name: "NotificationsStepAssets",
  components: {
    NotificationsAssets: () =>
      import("@/components/notifications/NotificationsAssets"),
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let assetTypes = lodashCloneDeep(NOTIFICATION_ASSET_TYPES);
    assetTypes = lodashOrderBy(assetTypes, ["order"], ["asc"]);

    const typesDisabled = [
      NOTIFICATION_ASSET_TYPE_RISK_RATING,
      NOTIFICATION_ASSET_TYPE_SAVED_SEARCH,
    ];
    if (!this.featureUnlocked("alerts-assets-hotspots")) {
      typesDisabled.push(NOTIFICATION_ASSET_TYPE_HOTSPOT);
    }
    return {
      assetTypes: assetTypes,
      errorMessageName: null,
      typeRiskRating: NOTIFICATION_ASSET_TYPE_RISK_RATING,
      typeVerifiedEvent: NOTIFICATION_ASSET_TYPE_VERIFIED_EVENT,
      typeHotspot: NOTIFICATION_ASSET_TYPE_HOTSPOT,
      typeSavedQuery: NOTIFICATION_ASSET_TYPE_SAVED_SEARCH,
      typesDisabled: typesDisabled,
    };
  },
  computed: {
    ...mapGetters({
      notification: MODULE_PREFIX_NOTIFICATIONS + "notification",
    }),
    assetTypeTitle() {
      if (lodashGet(this.notification, "formatted.docType")) {
        const assetType = lodashFind(this.assetTypes, [
          "value",
          this.notification.formatted.docType,
        ]);
        if (assetType && assetType.text) {
          return assetType.text;
        }
      }
      return null;
    },
  },
  methods: {
    handleChangeName(value) {
      const notification = lodashCloneDeep(this.notification);
      notification.formatted = notification.formatted || {};
      notification.formatted.name = value;
      this.update(notification);
    },
    handleChangeAssetType(value) {
      const notification = lodashCloneDeep(this.notification);
      notification.formatted = notification.formatted || {};
      notification.formatted.docType = value;
      notification.formatted.sharedList = [];
      this.update(notification);
    },
    update(notification) {
      this.$store.dispatch(
        MODULE_PREFIX_NOTIFICATIONS + GET_NOTIFICATION,
        notification
      );
    },
  },
  watch: {},
};
</script>

<style>
.hyp-types .v-btn-toggle {
  display: flex !important;
  flex-direction: column !important;
}
</style>
<style scoped></style>
